(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('r2b-collection-description')) {
    customElements.define(
      'r2b-collection-description',
      class extends HTMLElement {
        connectedCallback() {
          this.text = this.querySelector('.collection-description');
          this.button = this.querySelector('button');
          if (!this.text || !this.button) return;

          this.mobile = window.matchMedia('(max-width: 767px)');

          this.update = () => {
            if (!this.mobile.matches) {
              this.classList.remove('is-open');
            }

            const expanded = this.classList.contains('is-open');
            const overflowing =
              this.text.scrollHeight > this.text.clientHeight + 1;

            this.button.hidden =
              !this.mobile.matches || (!expanded && !overflowing);

            this.button.setAttribute('aria-expanded', String(expanded));
            this.button.textContent = expanded
              ? this.button.dataset.labelLess
              : this.button.dataset.labelMore;
          };

          this.toggle = () => {
            this.classList.toggle('is-open');
            this.update();
          };

          this.button.addEventListener('click', this.toggle);
          this.mobile.addEventListener('change', this.update);
          this.classList.add('is-ready');

          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.text);
          this.update();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.button?.removeEventListener('click', this.toggle);
          this.mobile?.removeEventListener('change', this.update);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          setTimeout(function(){
          let carouselElement = document.querySelector('.product-recommendations .recommended-products');
          if (carouselElement) {
              let slickOptions = {
                  arrow: false,
                  infinite: false,
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  responsive: [
                      {
                          breakpoint: 1024,
                          settings: {
                              slidesToShow: 2,
                              slidesToScroll: 1,
                              arrow: true
                          }
                      },
                      {
                          breakpoint: 600,
                          settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              arrow: true
                          }
                      }
                  ]
              };
      
              if (typeof window.jQuery === 'undefined') {
                  carouselElement.classList.add('slick-initialized');
                  new window.Slick(carouselElement, slickOptions);
              } else {
                  $(carouselElement).slick(slickOptions);
              }
          }

              // Keep recommended-product variant logic scoped to this section only,
              // so it cannot affect main PDP variant behavior.
              function bindRecommendationsVariantSelection(rootEl) {
                if (!rootEl || rootEl.dataset.recommendationsVariantBound === 'true') return;
                rootEl.dataset.recommendationsVariantBound = 'true';

                function handleRadioSelection(input) {
                  if (!input || !input.matches('.tt-options-swatch input[type="radio"]')) return;
                  const card = input.closest('.rt-product-card');
                  if (!card || !rootEl.contains(card)) return;

                  const varId = input.getAttribute('var_id');
                  const clickedName = input.name;
                  const clickedValue = input.value;
                  const clickedOptionIndex = input.getAttribute('optionIndex');
                  const addToCartForm = card.querySelector('.add-to-cart-form [name="id"]');
                  if (addToCartForm && varId) {
                    addToCartForm.value = varId;
                  }

                  input.checked = true;
                  input.setAttribute('checked', 'checked');

                  const reapplyChecked = () => {
                    try {
                      const groupRadios = clickedOptionIndex
                        ? card.querySelectorAll(`input[type="radio"][optionIndex="${clickedOptionIndex}"]`)
                        : card.querySelectorAll('input[type="radio"][name="' + clickedName + '"]');

                      groupRadios.forEach(r => {
                        const shouldBeChecked = r.name === clickedName && r.value === clickedValue;
                        r.checked = shouldBeChecked;
                        if (shouldBeChecked) {
                          r.setAttribute('checked', 'checked');
                        } else {
                          r.removeAttribute('checked');
                        }
                      });

                      if (addToCartForm && varId) addToCartForm.value = varId;
                    } catch (err) {}
                  };

                  reapplyChecked();
                  setTimeout(reapplyChecked, 80);

                  if(typeof Globo != 'undefined' && typeof Globo?.Preorder != 'undefined') {
                    const preorderForm = card.querySelector('form.gridProductPreOrderForm');
                    if (preorderForm) {
                      preorderForm.classList.remove('preorderLoaded');
                      Globo?.Preorder?.initCollection();
                    }
                  }
                }

                rootEl.addEventListener('change', function(e) {
                  handleRadioSelection(e.target);
                }, true);

                rootEl.addEventListener('click', function(e) {
                  const target = e.target;
                  const input = target && target.matches && target.matches('.tt-options-swatch input[type="radio"]')
                    ? target
                    : target.closest && target.closest('.tt-options-swatch input[type="radio"]');
                  handleRadioSelection(input);
                }, true);
              }

              bindRecommendationsVariantSelection(productRecommendationsSection);
            },1000);
        }
        if(typeof Globo != 'undefined' && typeof Globo?.Preorder != 'undefined') Globo?.Preorder?.initPreorder();
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);


  } catch(e) { console.error(e); }
})();
})();
